import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import { Button, Modal } from 'react-bootstrap'

import { toast } from 'react-toastify'

import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import Dialog from '../../services/Dialogs'

import moment from 'moment'


const ModalCambioMetaUsuario = ( params : any ) => {

  const { show, handleClose, usuario } = params



  const dialog = new Dialog();





  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
          meta_mensual_estrategias : yup.number().required(mensajes_validacion_generico),
  });



const [ envio_server, setSeEnvio ] = useState<boolean>(false)


const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update(`usuario_meta/${usuario.uuid}`, { ...registro })

        if(res_){
          toast.success('Se actualizó la Meta de este usuario')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}



  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Meta del Usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(usuario)
          }


          <p className="nm"><small>Usuario</small></p>
          <h4>{usuario.nombres} {usuario.paterno} {usuario.materno} </h4>



    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{
            meta_mensual_estrategias : usuario.meta_mensual_estrategias,

      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
        <Form id='my-form' noValidate onSubmit={handleSubmit}>




            <Form.Group   className="mb-3" controlId="meta_mensual_estrategias">
              <Form.Label>Meta</Form.Label>
              <Form.Control 
                required
                name="meta_mensual_estrategias"
                value={values.meta_mensual_estrategias}
                onChange={(e)=>{ setFieldValue('meta_mensual_estrategias', (e.target.value) ) }}
                isInvalid={!!errors.meta_mensual_estrategias}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
            </Form.Group>

        </Form>
      )}
    </Formik>






        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="success" form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>

        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalCambioMetaUsuario;